// https://developers.google.com/analytics/devguides/collection/ga4/ecommerce?client_type=gtm#apply_promotions
// https://developers.google.com/analytics/devguides/collection/ga4/reference/events?client_type=gtm

import TagManager from 'react-gtm-module';

export const gtmService = {
	sendSignUpEvent: (user_id: string, signupMethod: string) => {
		TagManager.dataLayer({
			dataLayer: {
				user_id,
				event: 'sign_up',
				method: signupMethod,
			},
		});
	},

	sendBeginCheckoutEvent: (user_id: string) => {
		TagManager.dataLayer({
			dataLayer: {
				user_id,
				event: 'begin_checkout',
			},
		});
	},

	sendAddPaymentInfoEvent: (payload: {
		currencyCode: string;
		value: number;
		couponCode: string;
		paymentType: string;
		userId: string;
	}) => {
		TagManager.dataLayer({
			dataLayer: {
				user_id: payload.userId,
				event: 'add_payment_info',
				ecommerce: {
					currency: payload.currencyCode,
					value: payload.value,
					coupon: payload.couponCode,
					payment_type: payload.paymentType,
					items: [
						{
							item_id: 'Annual',
							item_name: 'ClassPoint Annual Plan',
							coupon: payload.couponCode,
							item_brand: 'Inknoe ClassPoint',
							index: 0,
							price: payload.value,
							quantity: 1,
						},
					],
				},
			},
		});
	},

	sendPaymentSuccessfulEvent: (payload: {
		currencyCode: string;
		value: number;
		couponCode: string;
		paymentType: string;
		userId: string;
	}) => {
		TagManager.dataLayer({
			dataLayer: {
				user_id: payload.userId,
				event: 'purchase',
				ecommerce: {
					currency: payload.currencyCode,
					value: payload.value,
					coupon: payload.couponCode,
					payment_type: payload.paymentType,
					items: [
						{
							item_id: 'Annual',
							item_name: 'ClassPoint Annual Plan',
							coupon: payload.couponCode,
							item_brand: 'Inknoe ClassPoint',
							index: 0,
							price: payload.value,
							quantity: 1,
						},
					],
				},
			},
		});
	},
};
